import { defineMessage } from 'services/localization';

export const messages = {
    invite: defineMessage('invite'),
    inviteAgain: defineMessage('invite_again'),
    editRules: defineMessage('edit_rules'),
    editRulesRemovedUser: defineMessage('this_user_has_been_removed_from_the_organisation'),
    notInvitedUserTitle: defineMessage('name_has_not_yet_been_i_r_to_invite_this_person'),
};
